import { compact } from '../../../../helpers/compact';
import { toLink, toRichText, toText } from '../../fields';
import {
  LaPosteEn4Type,
  ProofCategorySlice,
} from '../../../../types/LaPosteEn4/slice';

const proofCategorySlice = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Record<string, any>
): ProofCategorySlice | undefined => {
  const title = toText(data.primary?.title);
  const theme = toText(data.primary?.theme);
  if (!title || !theme) {
    return undefined;
  }

  return compact({
    type: LaPosteEn4Type.PROOF_CATEGORY,
    title,
    theme,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    items: data.items.map((item: any) =>
      compact({
        icon: toText(item.icon),
        title: toText(item.title),
        description: toRichText(item.description),
        ctaLabel: toText(item.ctaLabel),
        ctaLink: toLink(item.ctaLink),
      })
    ),
  });
};

export default proofCategorySlice;
